export default __webpack_public_path__ + "static/media/court.5ab797c5.jpg";